// extracted by css-extract-rspack-plugin
export default {"InfoBlockButton":"kb7jK","HelpExternalLink":"Oeeox"};